import type { IspSportsAlias } from '@ps/web-sports-config';

import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Bet_on_the_N0_with_XXBrandXX_N_ELL,
  TXTWCL_FLGXNAMEXcompetitionX_N0_Betti_ELL
} from './sportsCompetition.messages.json';

const sportsCompetitionWidgets = (shouldApplyTennisGrouping: boolean) =>
  [
    {
      title: 'Sports Competition Events Widget',
      _content_type_uid: SportsWidgetType.SportsCompetitionEvents,
      shouldApplyTennisGrouping
    }
  ] satisfies readonly SectionWidgetConfig[];

export const sportsCompetition = ({
  alias
}: {
  alias: Extract<IspSportsAlias, 'sportsCompetition' | 'sportsTennisCompetition'>;
}) =>
  buildSportsLayoutPageResponse({
    alias,
    seoConfig: {
      apiPath: '/meta/competition/',
      descriptionTag: TXTWCL_Bet_on_the_N0_with_XXBrandXX_N_ELL,
      redirectTo: 'sportsSport',
      redirectStatusCode: 302,
      titleTag: TXTWCL_FLGXNAMEXcompetitionX_N0_Betti_ELL,
      translationsMap: {
        competition: 'competitionName',
        sport: 'eventTypeName'
      }
    },
    mainSectionWidgetConfigs: sportsCompetitionWidgets(alias === 'sportsTennisCompetition')
  });
